import React from 'react';
import { Play, Pause, ExternalLink } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { useAudioPlayer } from '../context/AudioPlayerContext';

export const EPCard = ({ ep }) => {
  const { currentTrack, isPlaying, playTrack } = useAudioPlayer();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handlePlayTrack = (track) => {
    playTrack(track, ep);
  };

  const handleImageError = (e) => {
    e.target.src = 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800&auto=format&fit=crop';
  };

  return (
    <Card className="bg-gradient-to-br from-purple-900/20 to-black border-purple-500/30 overflow-hidden hover:border-purple-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20">
      <div className="aspect-square relative overflow-hidden">
        <img 
          src={ep.cover_art ? `${BACKEND_URL}${ep.cover_art}` : 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800&auto=format&fit=crop'} 
          alt={ep.title}
          onError={handleImageError}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-white text-xl font-bold mb-1">{ep.title}</h3>
          <p className="text-purple-300 text-sm">{ep.release_date || ep.releaseDate}</p>
        </div>
      </div>
      
      <div className="p-4">
        <p className="text-purple-200 text-sm mb-4">{ep.description}</p>
        
        <div className="space-y-2">
          {ep.tracks && ep.tracks.map((track, index) => {
            const isCurrentTrack = currentTrack?._id === track._id;
            const isTrackPlaying = isCurrentTrack && isPlaying;
            
            return (
              <div 
                key={track._id}
                className={`flex items-center justify-between p-2 rounded-lg transition-colors ${
                  isCurrentTrack 
                    ? 'bg-purple-600/30' 
                    : 'hover:bg-purple-900/20'
                }`}
              >
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  {track.audio_url && (
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => handlePlayTrack(track)}
                      className="h-8 w-8 flex-shrink-0 text-purple-300 hover:text-white hover:bg-purple-500/20"
                    >
                      {isTrackPlaying ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
                    </Button>
                  )}
                  <div className="min-w-0 flex-1">
                    <p className={`text-sm truncate ${
                      isCurrentTrack ? 'text-purple-300 font-medium' : 'text-white'
                    }`}>
                      {index + 1}. {track.title}
                    </p>
                  </div>
                  <span className="text-purple-400 text-xs">{track.duration}</span>
                </div>
                
                {track.youtube_url && (
                  <Button
                    variant="ghost"
                    size="icon"
                    asChild
                    className="h-8 w-8 flex-shrink-0 text-purple-300 hover:text-white hover:bg-purple-500/20"
                  >
                    <a href={track.youtube_url} target="_blank" rel="noopener noreferrer">
                      <ExternalLink className="h-4 w-4" />
                    </a>
                  </Button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
};
